import { authRoles } from 'app/auth';
import i18next from 'i18next';
import OutlierDetectorTable from './table/OutlierDetectorTable';
import en from './i18n/en';
import hu from './i18n/hu';
import OutlierDetectorEditForm from './editform/OutlierDetectorEditForm';

i18next.addResourceBundle('en', 'outlierDetector', en);
i18next.addResourceBundle('hu', 'outlierDetector', hu);

export default [
	{
		path: '/outlier-detector/edit/:type/:id/:tabKey?',
		component: OutlierDetectorEditForm,
		auth: authRoles.outlierDetector
	},
	{
		path: '/outlier-detector/:sessionNameParam?',
		component: OutlierDetectorTable,
		auth: authRoles.outlierDetector
	}
];
